import request from '@/common/request'

class ICMSService {
  getAll(params) {
    return request.get('/icms', {
      params
    })
  }

  getById(icmsId) {
    return request.get(`/icms/${icmsId}`)
  }

  create(data) {
    return request.post('/icms', data)
  }

  update(id, data) {
    return request.patch(`/icms/${id}`, data)
  }

  deleteById(id) {
    return request.delete(`/icms/${id}`)
  }

  getUfsVinculadas() {
    return request.get('/icms/ufs')
  }

  criarValoresEntradaIcms(id, data) {
    return request.post(`/icms/${id}/valores-entrada`, data)
  }

  atualizarValoresEntradaIcms(icmsValorEntradaId, data) {
    return request.put(`/icms/valores-entrada/${icmsValorEntradaId}`, data)
  }

  buscarValoresEntradaIcms(icmsId) {
    return request.get(`/icms/${icmsId}/valores-entrada`)
  }

  removerValorEntradaIcms(icmsValorEntradaId) {
    return request.delete(`/icms/valores-entrada/${icmsValorEntradaId}`)
  }
}

export default new ICMSService()
